import { render, staticRenderFns } from "./Room1.vue?vue&type=template&id=879b4bbc&scoped=true&"
import script from "./Room1.vue?vue&type=script&lang=ts&"
export * from "./Room1.vue?vue&type=script&lang=ts&"
import style0 from "./Room1.vue?vue&type=style&index=0&id=879b4bbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879b4bbc",
  null
  
)

export default component.exports